var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M500.12,177.14,424,131.47V24a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8V131.47L11.88,177.14A8,8,0,0,0,8,184V488a8,8,0,0,0,8,8H496a8,8,0,0,0,8-8V184A8,8,0,0,0,500.12,177.14ZM424,150.13,487.12,188,424,225.87ZM104,32H408V235.47l-152,91.2-152-91.2ZM88,150.13v75.74L24.88,188ZM24,480V206.13l144.5,86.7L43.72,480Zm38.95,0L182.23,301.07l69.65,41.79a8.015,8.015,0,0,0,8.24,0l69.64-41.79L448.12,480ZM488,480H467.3L343.5,292.83,488,206.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,224a24,24,0,1,0,24,24A24.027,24.027,0,0,0,256,224Zm0,32a8,8,0,1,1,8-8A8.009,8.009,0,0,1,256,256Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,128h32a8,8,0,0,0,8-8,24,24,0,1,1,24,24H240a8,8,0,0,0-8,8v56a8,8,0,0,0,8,8h32a8,8,0,0,0,8-8V187.91A72.011,72.011,0,1,0,184,120,8,8,0,0,0,192,128Zm64-64a56.013,56.013,0,0,1,14,110.243,8,8,0,0,0-6,7.747V200H248V160h8a40,40,0,1,0-39.2-48H200.57A56.086,56.086,0,0,1,256,64Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.2c04a2ecb201d35628f31fa43da3fafa.svg";
export { ForwardRef as ReactComponent };